export default __webpack_public_path__ + "static/costco-011e0bf6ea312a1cd843f244e6155cc8.png";